import { gql } from '@apollo/client';

export const DELETE_PICKUP_ROUTE = gql`
  mutation DeletePickupRoute($id: Long!) {
    deletePickupRoute(id: $id)
  }
`;
